import ItemsI from '../types.ts';

const checkLoading: ItemsI['checkLoading'] = function (this: ItemsI) {
    return !this.state.isReady || !!this.state.isLoadingFilter;
};

export default checkLoading;
